const { q } = require('../helpers.js');

export const txtInsuredCNP = q('#txtInsuredCNP');
export const btnInsuredCNPTooltip = q('#btnInsuredCNPTooltip');
export const ddlPostcode = q('#ddlPostcode');
export const txtInsuredCity = q('#txtInsuredCity');
export const txtInsuredStreetAddress = q('#txtInsuredStreetAddress');
export const ddlInsuredDistrict = q('#ddlInsuredDistrict');
export const txtInsuredDate = q('#txtInsuredDate');
export const btnInsuredDateTooltip = q('#btnInsuredDateTooltip');
export const btnInsuredNext = q('#btnInsuredNext');
export const btnInsuredBack = q('#btnInsuredBack');